import React, { FunctionComponent, useState, useCallback } from 'react';
import { Presentation } from './presentation';
import { useDevice } from '../../../hooks/device';
import type { Props } from './types';

export const Component: FunctionComponent<Props> = ({
  isAllStoppedRecruitments,
  company,
  companyId,
  adminBrandId,
  user,
  coverNoImg,
  instagramIcon,
  lineIcon,
  noimage,
  hoverIcon,
  isCompany,
  isPage,
  h1Title,
  description,
  occupations,
  preferredOccupations,
  occupationDetails,
  graduationArray,
  graduationAnnotaion,
  prefectures,
  hasAnyRecruitments,
  isShowAttentionPeople,
  isStoppedFv,
}) => {
  const { isPc, chromeEdg } = useDevice();
  const [isShowingStoppedList, setIsShowingStoppedList] = useState(window.location.search.includes('status=stopped'));

  const pathParts = window.location.pathname.split('/');
  const brandId = Number(pathParts[pathParts.length - 1] || pathParts[pathParts.length - 2]);

  const handleToggleStoppedList = useCallback(() => {
    const newStatus = !isShowingStoppedList;
    setIsShowingStoppedList(newStatus);

    const url = new URL(window.location.href);
    if (newStatus) {
      url.searchParams.set('status', 'stopped');
    } else {
      url.searchParams.delete('status');
    }
    window.history.pushState({}, '', url.toString());
  }, [isShowingStoppedList]);

  return (
    <Presentation
      brandId={brandId}
      isAllStoppedRecruitments={isAllStoppedRecruitments}
      company={company}
      companyId={companyId}
      adminBrandId={adminBrandId}
      user={user}
      coverNoImg={coverNoImg}
      instagramIcon={instagramIcon}
      lineIcon={lineIcon}
      noimage={noimage}
      hoverIcon={hoverIcon}
      isCompany={isCompany}
      isPage={isPage}
      h1Title={h1Title}
      description={description}
      isPc={isPc}
      chromeEdg={chromeEdg}
      occupations={occupations}
      preferredOccupations={preferredOccupations}
      occupationDetails={occupationDetails}
      graduationArray={graduationArray}
      graduationAnnotaion={graduationAnnotaion}
      prefectures={prefectures}
      hasAnyRecruitments={hasAnyRecruitments}
      isShowAttentionPeople={isShowAttentionPeople}
      isStoppedFv={isStoppedFv}
      isShowingStoppedList={isShowingStoppedList}
      handleToggleStoppedList={handleToggleStoppedList}
    />
  );
};
